// extracted by mini-css-extract-plugin
module.exports = {"methodIcon":"previousEntriesPreviewStyles_methodIcon__26Pwx"};